// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52575a13","389":"b394324d","732":"6b3270d4","885":"334bd45f","977":"b4623321"}[chunkId] + ".chunk.js";
};